
import { employeeID, companyID } from "./UIComponents";

export { employeeID, companyID };

export const checkAccess = () => true;

export const Button = ({
  name,
  isClosebutton,
  btnclass,
  type = "button",
  onclick,
  title,
  DisplayName,
  disabled = false,
}) => {
  // formbuilder.js's own call sites are the tell: Save passes no btnclass
  // (the primary action); Form Preview / Download Excel pass one (secondary).
  const isPrimary = !isClosebutton && !btnclass;
  return (
    <button
      type={type}
      title={title}
      disabled={disabled}
      onClick={(event) => {
        event.preventDefault();
        if (onclick) onclick(true, event);
      }}
      className={
        isClosebutton
          ? "inline-flex items-center gap-2 px-5 h-11 rounded-xl text-[#3e494a] text-sm font-semibold border border-[#e5e9e9] hover:bg-[#f1f4f4] transition-all disabled:opacity-50"
          : isPrimary
            ? "inline-flex items-center gap-2 px-5 h-11 rounded-xl text-white text-sm font-bold hover:brightness-110 active:scale-[0.98] transition-all disabled:opacity-50"
            : "inline-flex items-center gap-2 px-5 h-11 rounded-xl text-[#08757C] text-sm font-bold border border-[#08757C]/30 hover:bg-[#e4f2f2] transition-all disabled:opacity-50"
      }
      style={isPrimary ? { background: "#08757C" } : undefined}
    >
      {DisplayName ? DisplayName : name}
    </button>
  );
};
